import React from 'react';
import { ProjectRelativeLink } from '@/components/navigation';
import theme from './ResidentialUnitListItem.module.scss';
import { CardSection, CardTags } from '@/components/Cards';
import { Trans } from '@lingui/react/macro';
import ResidentialUnitContextMenu from '@/seller/components/residential-units/ResidentialUnitContextMenu';
import ResidentialListItemBuyerSection from '../../ResidentialListItemBuyerSection';
import { ResidentialUnitListItemProps } from '..';
import { SelectableCard } from '@ygtechnologies/bygr-frontend-component-library';
import { useLingui } from '@lingui/react';

const ResidentialUnitListItem: React.FC<ResidentialUnitListItemProps> = ({
    hrefGenerator,
    residentialUnit,
    onDelete,
    onUpdate,
    notificationCountGetter = () => 0,
    selectedUnitIds = [],
    onUnitSelect,
}) => {
    const { _ } = useLingui();
    const isSelected = selectedUnitIds.includes(residentialUnit.id);

    const handleSelectionChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (onUnitSelect) {
            onUnitSelect(residentialUnit.id, e.target.checked);
        }
    };

    return (
        <SelectableCard
            isSelected={isSelected}
            handleSelectionChange={handleSelectionChange}
            notificationBadgeNumber={notificationCountGetter(residentialUnit.id)}>
            <div className={theme.listContainer}>
                <div className={theme.listContainerRow}>
                    <CardSection
                        className={theme.mainCard}
                        contentClassName={theme.cardSection}
                        caption={
                            <ProjectRelativeLink
                                className="link-unstyled flex full-width"
                                to={hrefGenerator(residentialUnit)}>
                                {residentialUnit.name}
                            </ProjectRelativeLink>
                        }>
                        <ProjectRelativeLink className="link-unstyled flex full-width" to={hrefGenerator(residentialUnit)}>
                            <ResidentialListItemBuyerSection buyerInfo={residentialUnit.buyerInfo} />
                        </ProjectRelativeLink>
                    </CardSection>
                    <CardSection
                        className={theme.card}
                        contentClassName={theme.cardSection}
                        caption={<Trans>Unit type</Trans>}>
                        {_({ id: `ResidentialUnitType.${residentialUnit.type}` })}
                    </CardSection>
                    <CardSection
                        className={theme.card}
                        contentClassName={theme.cardSection}
                        caption={<Trans>Layout type</Trans>}>
                        {residentialUnit.layoutType || '-'}
                    </CardSection>
                    <CardSection className={theme.card} contentClassName={theme.cardSection} caption={<Trans>Floor</Trans>}>
                        {residentialUnit.floor || '-'}
                    </CardSection>
                    <CardSection
                        className={theme.card}
                        contentClassName={theme.cardSection}
                        caption={<Trans>Readonly</Trans>}>
                        {residentialUnit.isReadOnlyForBuyers ? <Trans>Yes</Trans> : <Trans>No</Trans>}
                    </CardSection>

                    <ResidentialUnitContextMenu inCard onDelete={onDelete} onUpdate={onUpdate} residentialUnit={residentialUnit} />
                </div>
                <CardTags tags={residentialUnit.projectTags} />
            </div>
        </SelectableCard>
    );
};

export default React.memo(ResidentialUnitListItem);
